/* PIPEFY AGENTIC — Lola Mora
   Evita que se muestre la lista de tallas duplicada en las tarjetas de producto.
   Deja siempre una sola fila de tallas por producto (la primera renderizada). */
(function () {
  if (window.__pipefyFixTallas) return;
  window.__pipefyFixTallas = true;

  var SEL_CARD = '.t4s-product, .t4s-pr-grid, .t4s-product-wrapper';
  var SEL_SIZE = '.t4s-product-sizes';

  function dedupe(root) {
    (root || document).querySelectorAll(SEL_CARD).forEach(function (card) {
      if (card.closest(SEL_CARD) !== card && card.parentElement && card.parentElement.closest(SEL_CARD)) return;
      var rows = card.querySelectorAll(SEL_SIZE);
      if (rows.length < 2) return;
      var keep = rows[0];
      var seen = {};
      seen[(keep.textContent || '').replace(/\s+/g, ' ').trim()] = true;
      for (var i = 1; i < rows.length; i++) {
        var txt = (rows[i].textContent || '').replace(/\s+/g, ' ').trim();
        if (seen[txt]) {
          rows[i].setAttribute('data-pipefy-dup', 'true');
          rows[i].style.display = 'none';
        } else {
          seen[txt] = true;
        }
      }
    });
  }

  var timer = null;
  function schedule(root) {
    clearTimeout(timer);
    timer = setTimeout(function () { dedupe(root); }, 60);
  }

  if (document.readyState !== 'loading') schedule();
  else document.addEventListener('DOMContentLoaded', function () { schedule(); });
  window.addEventListener('load', function () { schedule(); });
  document.addEventListener('shopify:section:load', function (e) { schedule(e.target); });

  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
